<template>
  <div class="DialogReportHistory__Component">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">היסטורית אירועים</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <div class="history-container" v-if="rows">
          <table class="table">
            <thead>
              <tr>
                <th :key="index" v-for="(header, index) in rows.keys">
                  {{ header }}
                </th>
              </tr>
            </thead>
            <tr v-for="(row, index) in rows.values" :key="index" :class="{ 'current-item': index === 0 }">
              <td :key="index" v-for="(value, index) in row">{{ value }}</td>
            </tr>
          </table>
        </div>
        <b-pagination v-if="rows" :total="data.Total" v-model="currentPage" :range-before="2" :range-after="2"
          @change="onPageChange" :order="'is-centered'" :size="'is-small'" :per-page="10" aria-next-label="דף הבא"
          aria-previous-label="דף קודם" aria-page-label="דף" aria-current-label="דף נוכחי">
        </b-pagination>
        <h1 v-if="!rows">אין אירועים</h1>
      </section>
      <footer class="modal-card-foot">
        <b-button label="סגור" @click="$emit('close')" />
      </footer>
    </div>
  </div>
</template>

<script>
import ArchiveService from '@/services/ArchiveService';

export default {
  name: "DialogReportHistory",
  props: ["data", "Id", "historyType"],
  data() {
    return {
      currentPage: 1
    };
  },
  computed: {
    rows() {
      const { CurrentItem, Items } = this.data;
      // set the date to the current date
      CurrentItem.ArchiveDate = "נוכחי";
      Items.unshift(CurrentItem);
      return (
        Items[0] && {
          keys: Object.keys(Items[0]),
          values: Items.map((i) => Object.values(i)),
          //   values: this.data.Items.map((i) => {
          //     const arrVal = Object.values(i);
          //     // const arrKey = Object.keys(i);
          //     // arrKey.forEach((k, idx) => {
          //     //   if (
          //     //     k === "RentalPickUpFormHtml" ||
          //     //     k === "RentalReturnFormHtml" ||
          //     //     k === "DriversLicenseHtml" ||
          //     //     k === "TransferHtml"
          //     //   ) {
          //     //     arrVal[idx] = !!arrVal[idx];
          //     //   }
          //     // });
          //     return arrVal;
          //   }),
        }
      );
    },
  },
  methods: {
    onPageChange() {
      this.getHistoryByType();
    },
    getHistoryByType() {
      // if it null or report, get report history
      if (!this.historyType || this.historyType === 'report') {
        ArchiveService.getHistory(this.Id, 10, this.currentPage).then((r) => {
          this.rows.keys = Object.keys(r.data.Items[0]);
          this.rows.values = r.data.Items.map((i) => Object.values(i));
          this.$forceUpdate();
        }).catch(() => {
          this.$buefy.toast.open({
            message: 'אירועים לא נמצאו',
            type: 'is-danger'
          });
        });
      } else if (this.historyType === 'vehicle') {
        ArchiveService.getVehicleHistory(this.Id, 10, this.currentPage).then((r) => {
          this.rows.keys = Object.keys(r.data.Items[0]);
          this.rows.values = r.data.Items.map((i) => Object.values(i));
          this.$forceUpdate();
        }).catch(() => {
          this.$buefy.toast.open({
            message: 'אירועים לא נמצאו',
            type: 'is-danger'
          });
        });
      } else if (this.historyType === 'vehicle-contract') {
        // get vehicle contract history, and convert html to boolean
        ArchiveService.getVehicleContractHistory(this.Id, 10, this.currentPage).then((r) => {
          r.data.Items.forEach((item) => {
            item.DriversLicenseHtml = !!item.DriversLicenseHtml;
            item.RentalPickUpFormHtml = !!item.RentalPickUpFormHtml;
            item.RentalReturnFormHtml = !!item.RentalReturnFormHtml;
            item.TransferHtml = !!item.TransferHtml;
          });
          this.rows.keys = Object.keys(r.data.Items[0]);
          this.rows.values = r.data.Items.map((i) => Object.values(i));
          this.$forceUpdate();
        }).catch(() => {
          this.$buefy.toast.open({
            message: 'אירועים לא נמצאו',
            type: 'is-danger'
          });
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.DialogReportHistory__Component {
  ::v-deep .modal-card {
    width: 100% !important;
    height: 1200px;
  }

  ::v-deep .modal-card-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
}

.history-container {
  height: 100%;
  overflow: auto;
}

::v-deep .pagination {
  justify-content: center;
  direction: ltr;
  margin: 0;

  .pagination-list {
    flex-grow: unset;
  }
}
.current-item {
  background-color: #c1cdff66;
  font-weight: bold;
}
</style>;
